// extracted by mini-css-extract-plugin
export default {"card":"healthfactscard_card__h8vun","cardTitle":"healthfactscard_cardTitle__puJ7b","cardDesc":"healthfactscard_cardDesc__D3JMO"};